import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';

const defaultRiderState = {
  allDrivers: [],
  availableDrivers: [],
  unavailableDrivers: [],
  favoriteDrivers: [],
  // Timestamps for each data type
  lastUpdated: {
    favoriteDrivers: null,
    availableDrivers: null,
    unavailableDrivers: null,
  },
};

// Rider store
export const useRiderStore = create(
  devtools(
    persist(
      (set, get) => ({
        ...defaultRiderState,

        // Favorite drivers
        setFavoriteDrivers: (drivers) =>
          set({
            favoriteDrivers: drivers,
            lastUpdated: {
              ...get().lastUpdated,
              favoriteDrivers: Date.now(),
            },
          }),

        addFavoriteDriver: (driver) => {
          const currentFavorites = get().favoriteDrivers;
          if (!currentFavorites.some((fav) => fav.id === driver.id)) {
            set({
              favoriteDrivers: [...currentFavorites, driver],
              lastUpdated: {
                ...get().lastUpdated,
                favoriteDrivers: Date.now(),
              },
            });
          }
        },

        removeFavoriteDriver: (driverId) =>
          set((state) => ({
            favoriteDrivers: state.favoriteDrivers.filter(
              (driver) => driver.id !== driverId
            ),
            lastUpdated: {
              ...state.lastUpdated,
              favoriteDrivers: Date.now(),
            },
          })),

        // Available/unavailable drivers
        setAvailableDrivers: (drivers) => set({ availableDrivers: drivers }),
        setUnavailableDrivers: (drivers) => set({ unavailableDrivers: drivers }),
        setAllDrivers: (drivers) => set({ allDrivers: drivers }),

        // Reset
        resetRiderState: () => set(defaultRiderState),
      }),
      {
        name: 'rider-storage',
        storage: createJSONStorage(() => localStorage),
      }
    ),
    { name: 'Rider Store' }
  )
);
